var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_967_247762)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3239 2.51849C18.1544 2.33814 17.9759 2.1651 17.789 2.00008C16.3286 0.711234 14.4478 0 12.5 0C10.5522 0 8.67145 0.711234 7.21105 2.00008C5.75065 3.28893 4.81113 5.06669 4.569 6.99937H9.5C9.76522 6.99937 10.0196 7.10473 10.2071 7.29227C10.3946 7.4798 10.5 7.73416 10.5 7.99937C10.5 8.26459 10.3946 8.51894 10.2071 8.70648C10.0196 8.89402 9.76522 8.99937 9.5 8.99937H4.5V10.9994H9.5C9.6019 10.9994 9.70219 11.0149 9.7977 11.0447L18.3239 2.51849ZM7.84304 12.9994H4.569C4.67969 13.8829 4.93614 14.7341 5.32146 15.521L7.84304 12.9994ZM3.57875 17.2637C2.87874 15.9648 2.50183 14.5016 2.5 12.9994C2.5 12.7342 2.39464 12.4798 2.20711 12.2923C2.01957 12.1047 1.76522 11.9994 1.5 11.9994C1.23478 11.9994 0.98043 12.1047 0.792893 12.2923C0.605357 12.4798 0.5 12.7342 0.5 12.9994C0.502404 15.0374 1.06963 17.0165 2.11483 18.7276L3.57875 17.2637ZM4.79001 21.7093L6.21812 20.2811C7.74421 21.3887 9.59054 21.997 11.5 21.9994H13.5C15.8861 21.9967 18.1738 21.0477 19.861 19.3604C21.5483 17.6732 22.4974 15.3855 22.5 12.9994C22.5 12.7342 22.6054 12.4798 22.7929 12.2923C22.9804 12.1047 23.2348 11.9994 23.5 11.9994C23.7652 11.9994 24.0196 12.1047 24.2071 12.2923C24.3946 12.4798 24.5 12.7342 24.5 12.9994C24.4966 15.9157 23.3365 18.7116 21.2744 20.7738C19.2122 22.8359 16.4163 23.9959 13.5 23.9994H11.5C9.0591 23.9965 6.70257 23.1834 4.79001 21.7093ZM7.93343 18.5658L14.5 11.9993C14.5 11.9993 14.5 11.9993 14.5 11.9994C14.5 12.2646 14.6054 12.5189 14.7929 12.7065C14.9804 12.894 15.2348 12.9994 15.5 12.9994H20.431C20.1889 14.9321 19.2494 16.7098 17.789 17.9987C16.3286 19.2875 14.4478 19.9987 12.5 19.9987C10.86 19.9987 9.26749 19.4945 7.93343 18.5658ZM15.4999 10.9994C15.4999 10.9994 15.5 10.9994 15.5 10.9994H20.5V8.99937H17.4999L15.4999 10.9994ZM19.4999 6.99937H20.431C20.3975 6.73236 20.3508 6.46831 20.2912 6.20809L19.4999 6.99937Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1.20711,
    y1: 26.2929,
    x2: 26.7929,
    y2: -1.70711,
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_967_247762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicMute);
export default __webpack_public_path__ + "static/media/mic_mute.e99eeebc0ab211cb6a677bcdb351e01d.svg";
export { ForwardRef as ReactComponent };